export const categories = [
  {
    slug: 'korea',
    name: '韩国漫画',
    description: '精选韩国无删减完整版漫画，下拉式流畅阅读体验，免费观看各类精彩韩漫。',
    image: 'https://readdy.ai/api/search-image?query=Korean%20webtoon%20style%20illustration%2C%20dramatic%20romance%20manhwa%20scene%20with%20two%20characters%20in%20emotional%20moment%2C%20warm%20golden%20and%20soft%20pink%20color%20palette%2C%20modern%20digital%20art%2C%20clean%20composition%2C%20soft%20gradient%20background%2C%20high%20quality%20Korean%20comic%20aesthetic&width=800&height=500&seq=cat-korea-hero&orientation=landscape',
  },
  {
    slug: 'shonen',
    name: '热血少年',
    description: '高燃热血少年漫画，激战冒险不停歇。完整版下拉式阅读，零删减免费观看。',
    image: 'https://readdy.ai/api/search-image?query=Action%20shonen%20manga%20style%20illustration%2C%20dynamic%20fight%20scene%20with%20young%20hero%20in%20mid-action%20pose%2C%20vibrant%20warm%20colors%2C%20orange%20and%20red%20energy%20effects%2C%20dramatic%20lighting%2C%20modern%20digital%20comic%20art%2C%20clean%20background%2C%20epic%20atmosphere&width=800&height=500&seq=cat-shonen-hero&orientation=landscape',
  },
  {
    slug: 'romance',
    name: '恋爱言情',
    description: '甜蜜浪漫恋爱漫画，心动剧情尽收眼底。完整版无删减免费阅读，下拉式流畅观看。',
    image: 'https://readdy.ai/api/search-image?query=Romantic%20shoujo%20manga%20illustration%2C%20couple%20under%20cherry%20blossom%20trees%2C%20soft%20pink%20and%20pastel%20color%20palette%2C%20dreamy%20atmosphere%2C%20floating%20petals%2C%20modern%20digital%20comic%20art%2C%20gentle%20warm%20lighting%2C%20clean%20minimal%20background&width=800&height=500&seq=cat-romance-hero&orientation=landscape',
  },
  {
    slug: 'new',
    name: '最新上架',
    description: '最新漫画抢先看，每周持续更新。下拉式完整版免费阅读，不遗漏任何精彩。',
    image: 'https://readdy.ai/api/search-image?query=Manga%20bookshelf%20with%20colorful%20comic%20book%20covers%20displayed%2C%20warm%20ambient%20lighting%2C%20cozy%20reading%20atmosphere%2C%20modern%20minimal%20digital%20illustration%2C%20vibrant%20colors%2C%20clean%20composition%2C%20soft%20shadows%2C%20artistic%20style&width=800&height=500&seq=cat-new-hero&orientation=landscape',
  },
];

export const featuredComics = [
  {
    slug: 'dushi-lingzhu',
    title: '都市灵主',
    author: '金炫秀',
    category: 'korea',
    rating: 9.5,
    chapters: 126,
    status: '连载中',
    summary: '一个意外觉醒了灵力的普通大学生，在都市的暗处发现了另一个世界。灵异事件、神秘组织、前世今生的秘密...都将在他的面前一一揭开。',
    coverImage: 'https://readdy.ai/api/search-image?query=Korean%20webtoon%20manhwa%20cover%20art%2C%20urban%20fantasy%20theme%2C%20male%20protagonist%20with%20mysterious%20blue%20energy%20aura%2C%20city%20night%20background%2C%20modern%20stylish%20character%20design%2C%20dramatic%20lighting%2C%20professional%20comic%20cover%20composition%2C%20clean%20white%20background%20border&width=600&height=840&seq=comic-01-cover&orientation=portrait',
    tags: ['都市', '奇幻', '热门'],
    views: 1280000,
  },
  {
    slug: 'xinghe-zhanji',
    title: '星河战机',
    author: '朴正勋',
    category: 'shonen',
    rating: 9.3,
    chapters: 89,
    status: '连载中',
    summary: '公元2245年，人类进入星际时代。年轻的驾驶员林宇驾驶着传说中的机甲"星河"，为守护地球而奋战在星辰大海的最前线。',
    coverImage: 'https://readdy.ai/api/search-image?query=Korean%20webtoon%20sci-fi%20mecha%20cover%20art%2C%20giant%20robot%20in%20space%20battle%2C%20young%20male%20pilot%20with%20determined%20expression%2C%20futuristic%20setting%2C%20warm%20orange%20and%20blue%20color%20scheme%2C%20professional%20comic%20cover%2C%20clean%20composition&width=600&height=840&seq=comic-02-cover&orientation=portrait',
    tags: ['机甲', '科幻', '热门'],
    views: 960000,
  },
  {
    slug: 'huaijiu-qingren',
    title: '怀旧情人',
    author: '李恩珠',
    category: 'romance',
    rating: 9.6,
    chapters: 72,
    status: '已完结',
    summary: '高中时代的初恋，十年后的重逢。当初的误会能否解开？两颗受伤的心是否还能再次靠近？一段跨越十年的感人恋曲。',
    coverImage: 'https://readdy.ai/api/search-image?query=Korean%20webtoon%20romance%20cover%20art%2C%20couple%20embracing%20in%20autumn%20park%2C%20warm%20nostalgic%20color%20palette%2C%20soft%20golden%20hour%20lighting%2C%20emotional%20atmosphere%2C%20beautiful%20character%20design%2C%20professional%20comic%20cover&width=600&height=840&seq=comic-03-cover&orientation=portrait',
    tags: ['爱情', '怀旧', '完结'],
    views: 2150000,
  },
  {
    slug: 'modao-zongheng',
    title: '魔道纵横',
    author: '崔志成',
    category: 'korea',
    rating: 9.4,
    chapters: 145,
    status: '连载中',
    summary: '在被正道抛弃后，少年踏上了魔道之路。然而魔道中人就一定是恶吗？在这条充满荆棘的道路上，他要重新定义正与邪的界限。',
    coverImage: 'https://readdy.ai/api/search-image?query=Korean%20webtoon%20martial%20arts%20fantasy%20cover%20art%2C%20dark%20anti-hero%20protagonist%20with%20sword%2C%20mysterious%20purple%20and%20black%20color%20scheme%2C%20ancient%20oriental%20setting%2C%20dramatic%20pose%2C%20professional%20comic%20cover%2C%20clean%20composition&width=600&height=840&seq=comic-04-cover&orientation=portrait',
    tags: ['武侠', '奇幻', '热门'],
    views: 1830000,
  },
  {
    slug: 'tianshi-zhiyi',
    title: '天使之翼',
    author: '尹美娜',
    category: 'romance',
    rating: 9.2,
    chapters: 68,
    status: '连载中',
    summary: '在一次意外中，少女遇见了化身为人类的天使。禁忌的恋情就此展开，他们能否冲破天界的规则，守护彼此的爱？',
    coverImage: 'https://readdy.ai/api/search-image?query=Korean%20webtoon%20fantasy%20romance%20cover%20art%2C%20female%20protagonist%20with%20angel%20wings%2C%20ethereal%20white%20and%20gold%20color%20palette%2C%20dreamy%20heavenly%20atmosphere%2C%20beautiful%20character%20design%2C%20soft%20lighting%2C%20professional%20comic%20cover&width=600&height=840&seq=comic-05-cover&orientation=portrait',
    tags: ['奇幻', '爱情', '连载'],
    views: 870000,
  },
  {
    slug: 'lieyan-zhanshen',
    title: '烈焰战神',
    author: '姜泰浩',
    category: 'shonen',
    rating: 9.5,
    chapters: 200,
    status: '连载中',
    summary: '一场灾难性的战役之后，战士阿瑞斯发现自己拥有了操控火焰的神力。加入神秘组织"焰火会"，他将面对前所未有的强敌。',
    coverImage: 'https://readdy.ai/api/search-image?query=Korean%20webtoon%20action%20fantasy%20cover%20art%2C%20warrior%20surrounded%20by%20flames%2C%20intense%20red%20and%20orange%20color%20palette%2C%20epic%20battle%20pose%2C%20dramatic%20lighting%2C%20professional%20comic%20cover%2C%20clean%20composition&width=600&height=840&seq=comic-06-cover&orientation=portrait',
    tags: ['格斗', '超能', '热门'],
    views: 3100000,
  },
  {
    slug: 'yuexia-anying',
    title: '月下暗影',
    author: '宋志勋',
    category: 'korea',
    rating: 9.1,
    chapters: 98,
    status: '连载中',
    summary: '月圆之夜，普通高中生林澈发现自己继承了古老的暗影之力。在月光的指引下，他踏上了寻找真相的冒险。',
    coverImage: 'https://readdy.ai/api/search-image?query=Korean%20webtoon%20dark%20fantasy%20cover%20art%2C%20mysterious%20male%20character%20under%20moonlight%2C%20shadow%20powers%2C%20night%20scene%2C%20deep%20blue%20and%20silver%20color%20scheme%2C%20atmospheric%2C%20professional%20comic%20cover&width=600&height=840&seq=comic-07-cover&orientation=portrait',
    tags: ['悬疑', '奇幻', '连载'],
    views: 720000,
  },
  {
    slug: 'chuntian-huayuan',
    title: '春天花园',
    author: '韩素英',
    category: 'romance',
    rating: 9.7,
    chapters: 55,
    status: '已完结',
    summary: '搬进奶奶的旧房子后，少女在花园中发现了一个秘密——通往另一个世界的入口。在那里，她遇见了改变她一生的那个人。',
    coverImage: 'https://readdy.ai/api/search-image?query=Korean%20webtoon%20slice%20of%20life%20romance%20cover%20art%2C%20girl%20in%20flower%20garden%2C%20spring%20atmosphere%2C%20soft%20pastel%20pink%20and%20green%20color%20palette%2C%20dreamy%20warm%20lighting%2C%20beautiful%20illustration%2C%20professional%20comic%20cover&width=600&height=840&seq=comic-08-cover&orientation=portrait',
    tags: ['日常', '治愈', '完结'],
    views: 1650000,
  },
  {
    slug: 'jixian-chegnzhang',
    title: '极限成长',
    author: '郑宇镇',
    category: 'shonen',
    rating: 9.0,
    chapters: 112,
    status: '连载中',
    summary: '最弱的能力觉醒者李翰，在濒死之际获得了一个神秘系统。看弱者如何一步步逆袭成为最强！',
    coverImage: 'https://readdy.ai/api/search-image?query=Korean%20webtoon%20level-up%20action%20cover%20art%2C%20young%20male%20protagonist%20with%20determined%20look%2C%20game-like%20status%20window%20visual%20effects%2C%20modern%20urban%20background%2C%20vibrant%20blue%20and%20gold%20color%20scheme%2C%20professional%20comic%20cover&width=600&height=840&seq=comic-09-cover&orientation=portrait',
    tags: ['系统', '升级', '热门'],
    views: 2450000,
  },
];

export const testimonials = [
  {
    name: '漫画迷小王',
    role: '忠实读者 · 3年',
    avatar: 'https://readdy.ai/api/search-image?query=Asian%20young%20man%20portrait%2C%20casual%20style%2C%20friendly%20smile%2C%20clean%20simple%20background%2C%20warm%20lighting%2C%20professional%20headshot%2C%20natural%20expression%2C%20high%20quality&width=120&height=120&seq=avatar-01&orientation=squarish',
    content: '虫虫漫画网真的是我的宝藏网站！下拉式阅读太方便了，不用翻页直接往下滑，一口气能看好几十话。而且内容完全没有删减，画质清晰，加载速度也快。每天上下班路上都在看，已经推荐给身边所有朋友了！',
    rating: 5,
  },
  {
    name: '二次元少女酱',
    role: '漫画博主 · 5年',
    avatar: 'https://readdy.ai/api/search-image?query=Asian%20young%20woman%20portrait%2C%20stylish%20casual%20look%2C%20warm%20smile%2C%20clean%20simple%20background%2C%20soft%20lighting%2C%20professional%20headshot%2C%20natural%20expression%2C%20high%20quality&width=120&height=120&seq=avatar-02&orientation=squarish',
    content: '作为漫画博主，我阅漫无数。虫虫漫画的韩国漫画资源真的太全了！很多小众好漫在这里都能找到完整版，下拉观看的体验秒杀传统翻页模式。我经常在我的公众号推荐虫虫漫画，粉丝们也都很喜欢！',
    rating: 5,
  },
  {
    name: '程序员老张',
    role: '资深漫友 · 4年',
    avatar: 'https://readdy.ai/api/search-image?query=Asian%20middle-aged%20man%20portrait%2C%20casual%20glasses%2C%20friendly%20expression%2C%20clean%20simple%20background%2C%20warm%20lighting%2C%20professional%20headshot%2C%20natural%20look%2C%20high%20quality&width=120&height=120&seq=avatar-03&orientation=squarish',
    content: '写代码累了就看看漫画放松。虫虫漫画的流畅度真的没话说，下拉操作顺滑不卡顿，完美适配手机阅读。最重要的是免费！无删减！这在现在的漫画平台里太难得了。强烈安利！',
    rating: 5,
  },
  {
    name: '小雅爱追漫',
    role: '大学生读者 · 2年',
    avatar: 'https://readdy.ai/api/search-image?query=Asian%20young%20woman%20college%20student%20portrait%2C%20youthful%20style%2C%20bright%20smile%2C%20clean%20simple%20background%2C%20warm%20lighting%2C%20professional%20headshot%2C%20natural%20expression%2C%20high%20quality&width=120&height=120&seq=avatar-04&orientation=squarish',
    content: '室友推荐的虫虫漫画，看了一眼就停不下来！韩国漫画的画风真的太精致了，人物超好看，剧情也抓人心。下拉式阅读特别适合在床上躺着看，手指轻轻一滑就有新内容，太舒服了～',
    rating: 5,
  },
  {
    name: '漫谈老司机',
    role: '资深漫评人 · 6年',
    avatar: 'https://readdy.ai/api/search-image?query=Asian%20man%20portrait%2C%20mature%20look%2C%20thoughtful%20expression%2C%20clean%20simple%20background%2C%20warm%20lighting%2C%20professional%20headshot%2C%20natural%20pose%2C%20high%20quality&width=120&height=120&seq=avatar-05&orientation=squarish',
    content: '看了十几年漫画，虫虫漫画网是目前体验最好的平台之一。下拉式排版完美还原了韩漫的原生阅读感，无删减的内容呈现是对创作者和读者的双重尊重。平台更新速度也很快，紧跟韩国连载节奏。',
    rating: 5,
  },
];

export const siteStats = {
  totalComics: '2000+',
  totalReaders: '500万+',
  dailyActive: '30万+',
  monthlyUpdates: '300+',
};

export const features = [
  {
    icon: 'ri-book-read-line',
    title: '下拉式阅读',
    description: '原生韩国漫画下拉式排版，手指轻滑即可流畅阅读。告别传统翻页，沉浸式漫画体验从未如此顺滑自然。',
  },
  {
    icon: 'ri-lock-unlock-line',
    title: '完整无删减',
    description: '所有漫画内容均为完整版，坚决不删减任何剧情与画面。原汁原味呈现作者创作意图，让您看到每一帧精彩。',
  },
  {
    icon: 'ri-money-cny-circle-line',
    title: '完全免费',
    description: '海量漫画资源全部免费阅读，无需付费订阅即可畅享完整版剧情。我们相信好内容应该被更多人看到。',
  },
  {
    icon: 'ri-smartphone-line',
    title: '多端适配',
    description: '手机、平板、电脑全平台完美适配。无论您使用什么设备，都能获得最佳的下拉式阅读体验。',
  },
  {
    icon: 'ri-speed-up-line',
    title: '加载极速',
    description: '先进的图片加载技术，保证漫画页面秒开不卡顿。即使在网络不佳的环境下，也能流畅下拉观看。',
  },
  {
    icon: 'ri-chat-smile-2-line',
    title: '韩国正版',
    description: '精选韩国热门漫画平台优质内容，画风精致、剧情紧凑、更新稳定。为中国漫友带来最纯正的韩漫体验。',
  },
];